import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import { useMusic } from '../../context/MusicContext';
import './MusicPlayer.css';

const MusicPlayer = () => {
  // Drives the same shared player as the instructions screen, so controls and
  // playback state stay in sync and music never stops on screen transitions.
  const { isPlaying, volume, toggle, skip, toggleVolume } = useMusic();

  return (
    <div className="music-player">
      <button className="music-player__button" onClick={toggle} aria-label={isPlaying ? 'Pause' : 'Play'}>
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </button>

      <button className="music-player__button" onClick={skip} aria-label="Skip track">
        <SkipNextIcon />
      </button>

      <button className="music-player__button" onClick={toggleVolume} aria-label={volume === 1 ? 'Lower volume' : 'Raise volume'}>
        {volume === 1 ? <VolumeUpIcon /> : <VolumeDownIcon />}
      </button>
    </div>
  );
};

export default MusicPlayer;
